import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="section-shell site-footer__inner">
        <div>
          <p className="site-footer__brand">Ammen Consulting</p>
          <p className="site-footer__note">
            Medical device commercialization, sales operations, and analytics.
          </p>
        </div>

        <div className="site-footer__links">
          <Link className="site-footer__link" to="/terms-and-conditions">
            Terms and Conditions
          </Link>
          <Link className="site-footer__link" to="/privacy-policy">
            Privacy Policy
          </Link>
        </div>

        <p className="site-footer__copyright">
          &copy; {new Date().getFullYear()} Ammen Consulting
        </p>
      </div>
    </footer>
  );
};

export default Footer;
